import axios from 'axios';
import toast from 'react-simple-toasts';
import { getAuth, getDept } from '../data/utils';

export const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
	baseURL: baseUrl,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json',
	},
});

axiosInstance.interceptors.request.use(
	(config) => {
		const currentUser = getAuth() || ''
		const currentDept = getDept() || ''
		config.headers['X-Dash-User'] = currentUser.authID;
		config.headers['X-Dash-Dept'] = currentDept
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	(response) => {
		const isISODateString = (str) => {
			return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(str);
		};

		const convertDateStringsToDate = (data) => {
			if (typeof data === 'string' && isISODateString(data)) {
				return new Date(data);
			}

			if (Array.isArray(data)) {
				return data.map((item) => convertDateStringsToDate(item));
			}

			if (data !== null && typeof data === 'object') {
				for (let key in data) {
					if (data.hasOwnProperty(key)) {
						data[key] = convertDateStringsToDate(data[key]);
					}
				}
			}

			return data;
		};

		response.data = convertDateStringsToDate(response.data);

		return response;
	},
	async (error) => {
		// Handle persistent 401 error after retry
		if (error.response && error.response.status === 401) {
			console.error('Token expired or invalid. Redirecting to login...');

			localStorage.clear();
			window.location.href = '';
		}

		toast(error?.response?.data?.message || 'An error occurred', {
			duration: 5000,
			position: 'bottom-center',
			theme: 'failure',
		});

		return Promise.reject(error);
	}
);

export default axiosInstance;
